import { createStyles, Theme, makeUiStyles } from "../../styles/styles";
import { StylesIndexInjections } from "common-react";

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      overflow: 'hidden',
    },
    '& .Mui-error': {
      '& .MuiInputAdornment-root': {
        '&:before': {
          backgroundColor: theme.color.reds[100]
        }
      }
    },
    '& .Mui-disabled': {
      '& .MuiInputAdornment-root': {
        '&:before': {
          backgroundColor: theme.color.greys[20]
        }
      }
    },
    '& .MuiInputAdornment-root': {
      position: 'relative',
      marginTop: 0,
      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: -16,
        bottom: -16,
        width: 1,
        backgroundColor: theme.color.greys[40],
      }
    },
    '& .MuiInputAdornment-positionStart': {
      paddingRight: 24,
      marginRight: 16,
      '&:before': {
        left: '100%',
      }
    },
    '& .MuiInputAdornment-positionEnd': {
      paddingLeft: 16,
      marginRight: 8,
      marginLeft: 16,
      '&:before': {
        right: '100%',
      }
    },
  },
}), { name: 'NumberInput', index: StylesIndexInjections.UI_MOLECULES });
